import throttle from '../util/throttle'
/**
 * Set up desktop main menu.
 *
 * @param { HTMLElement } menuEl Menu element dom node
 */
export const setupSubMenus = (menuEl) => {
	// bail if we have nothing
	if (!menuEl) {
		return
	}

	// get all links that toggle submenus (blank links)
	const togglers = menuEl.querySelectorAll('[href="#"]')

	// handle activation
	const toggle = (toggledEl) => {
		const toggleActive = toggledEl ? toggledEl.classList.contains('active') : true
		togglers.forEach((linkEl) => {
			linkEl.classList.remove('active')
		})
		document.body.classList.toggle('sub-menu-active', !toggleActive)
		if (toggledEl) {
			toggledEl.classList.toggle('active', !toggleActive)
		}
	}

	// for each link
	togglers.forEach((linkEl) => {
		// bind activation to blank links
		linkEl.addEventListener('click', (e) => {
			e.preventDefault()
			toggle(linkEl)
		})
	})

	// bind deactivation on click outside submenu or its links
	document.addEventListener('click', (e) => {
		if (!e.target.href) {
			toggle(false)
		}
	})

	// handle scrolled show/hide versions of menu
	window.addEventListener(
		'scroll',
		throttle(function () {
			const st = window.pageYOffset || document.documentElement.scrollTop
			if (st < this.lastScrollTop) {
				menuEl.classList.remove('going-down')
			} else if (st > 0) {
				menuEl.classList.add('going-down')
			}
			this.lastScrollTop = st <= 0 ? 0 : st
			if (!this.permScrolledVersion && st > 100) {
				menuEl.classList.add('was-down')
				this.permScrolledVersion = true
				setTimeout(() => {
					menuEl.classList.add('is-animatable')
				}, 10)
			}
		}, 100),
		false
	)
}

/**
 * Set up mobile main menu.
 *
 * @param { HTMLElement } menuEl Menu element dom node
 */
export const setupMobileMenu = (menuEl) => {
	if (menuEl) {
		// grab the sub elements
		const trigger = menuEl.querySelector('#menu-trigger')
		const menu = trigger.nextElementSibling
		let timer = null

		// start out with the menu shown if we're at desktop
		if (getComputedStyle(trigger).display === 'none') {
			menu.setAttribute('aria-hidden', false)
		}

		// on click of the trigger show the menu (with accessibility)
		trigger.addEventListener('click', () => {
			const toggleActive = trigger.getAttribute('aria-expanded') === 'true'
			trigger.setAttribute('aria-expanded', !toggleActive)
			menu.setAttribute('aria-hidden', toggleActive)
			document.body.classList.toggle('menu-active', !toggleActive)
			// swap menu/close text
			trigger.firstElementChild.classList.add('is-changing')
			clearTimeout(timer)
			timer = setTimeout(() => {
				trigger.firstElementChild.textContent = toggleActive ? 'menu' : 'close'
				trigger.firstElementChild.classList.remove('is-changing')
			}, 150)
		})
	}
}

/**
 * Setup language menu
 * 
 * @param { HTMLElement } langMenuEl Country menu element dom node
 */
export const setupCountryMenu = (langMenuEl) => {
	if (langMenuEl) {
		// get the toggle element
		const langToggleEl = document.getElementById('country-toggle');
		// handle toggle
		const toggle = (force = null) => {
			const isActive = force !== null ? force : langToggleEl.getAttribute('aria-expanded') === 'true';
			langToggleEl.setAttribute('aria-expanded', ! isActive);
			langMenuEl.setAttribute('aria-hidden', isActive)
		}
		// on click o the toggle we toggle the menu
		langToggleEl.addEventListener('click', () => {
			const isActive = langToggleEl.getAttribute('aria-expanded') === 'true';
			langToggleEl.setAttribute('aria-expanded', ! isActive);
			langMenuEl.setAttribute('aria-hidden', isActive)
		});
		// bind deactivation on click outside submenu or its links
		document.addEventListener('click', (e) => {
			if (e.target !== langToggleEl && !e.target.href) {
				toggle(true)
			}
		});
	}
};